import { type WalletLedger } from '@capsicum/common';
import { type WalletFanTokenBalance, type WalletTotalBalance } from '@capsicum/socios-core';

export const enum TypeCurrency {
	Crypto = 'crypto',
	ExternalToken = 'externalToken',
	VoteToken = 'voteToken'
}

export type WalletCurrencyBalance = WalletFanTokenBalance & WalletTotalBalance;

export type WalletConvertedPrices = {
	altCurrency: WalletCurrencyBalance;
	defaultCurrency: WalletCurrencyBalance;
};

export type WalletTokenTotalBalance = {
	formattedTotalBalanceOfFanTokens?: string;
	rawTotalBalanceOfFanTokens?: string;
	walletConvertedPrices?: WalletConvertedPrices;
};

export type WalletFanToken = {
	availableTokenBalance?: string;
	hasEnoughAvailableToken?: (amount: number | string) => boolean;
	hasEnoughToken?: (amount: number | string) => boolean;
	ledger?: WalletLedger;
	partner: {
		blurHash?: string;
		id?: string;
		logo?: string;
		name?: string;
	};
	totalBalance?: number;
	tradableBalance?: string;
	walletConvertedPrices?: WalletConvertedPrices;
};

export interface WalletFanTokens {
	fanTokens?: Array<WalletFanToken>;
	favouriteFanToken?: WalletFanToken;
	loyaltyToken?: WalletFanToken;
	totalBalance?: WalletTokenTotalBalance;
}
